<template>
  <v-container fluid>
    <v-card class="elevation-10">
      <v-skeleton-loader
        :loading="loading"
        type="table-heading, table-thead, table-row-divider@12, table-tfoot"
      >
        <v-card-actions>
          <v-row>
            <v-col
              cols="4"
              md="3"
              xl="4"
            >
              <v-toolbar
                flat
              >
                <v-toolbar-title class="md-4 white--text">
                  Fund Bucket
                </v-toolbar-title>
              </v-toolbar>
            </v-col>
            <v-col
              cols="4"
              md="3"
              xl="4"
            >
              <v-text-field
                v-model="search"
                placeholder="Search"
                append-icon="fa fa-search"
                label="Search Fund Bucket"
                hide-no-data
                hide-selected
                clearable
              />
            </v-col>
            <v-col
              cols="2"
              md="3"
              xl="2"
            />
            <v-col
              cols="2"
              md="3"
              xl="2"
              class="mt-2 text-right"
            >
              <bucket-fund-bucket-dialog-create
                @created="loadData"
              />
            </v-col>
          </v-row>
        </v-card-actions>

        <v-data-table
          dense
          :headers="headers"
          :items="fundBuckets"
          :items-per-page="15"
          multi-sort
          class="scrollable-table elevation-10"
          :search="search"
          data-simplebar
        >
          <template v-slot:[`item.name`]="{ item }">
            <div>
              <span>
                {{ item.name }}
              </span>
            </div>
          </template>
          <template v-slot:[`item.group`]="{ item }">
            <div>
              <span>
                {{ item.group }}
              </span>
            </div>
          </template>
          <template v-slot:[`item.schemaName`]="{ item }">
            <div>
              <span v-if="item.schemaName">
                {{ item.schemaName }}
              </span>
              <span v-else>
                N/A
              </span>
            </div>
          </template>

          <template v-slot:[`item.action`]="{ item }">
            <bucket-fund-bucket-dialog-edit
              :fund-bucket="item"
              @updated="loadData"
            />
            <bucket-fund-bucket-dialog-delete
              :fund-bucket="item"
              @deleted="loadData"
            />
          </template>
        </v-data-table>
      </v-skeleton-loader>
    </v-card>

    <v-snackbar
      v-model="snack"
      bottom
      :color="snackColor"
      class="center-snackbar"
    >
      {{ snackText }}
    </v-snackbar>
  </v-container>
</template>

<script>
  export default {
    data () {
      return {
        loading: true,
        dialog: false,
        snack: '',
        snackColor: '',
        snackText: '',
        search: '',
        fundBuckets: [],
        headers: [
          { text: 'Name', value: 'name' },
          { text: 'Schema', value: 'schemaName' },
          { text: 'Quota Category', value: 'company_quota_category' },
          { text: 'Group', value: 'group' },
          { text: 'Action', value: 'action', align: 'center', class: 'md-2', sortable: false },
        ],
      }
    },
    created () {
      this.loadData()
    },
    methods: {
      loadData () {
        this.$api.fundBuckets().list()
          .then(response => {
            this.fundBuckets = response.data.map(function (fundBucket) {
              if (fundBucket.fund_bucket_has_types.length > 0) {
                fundBucket.schemaName = fundBucket.fund_bucket_has_types[0].schema_name
              }
              fundBucket.company_quota_category = fundBucket.company_quota_category ? fundBucket.company_quota_category.value : '-'
              return fundBucket
            })
            this.loading = false
          })
          .catch(err => {
            console.log(err)
          })
      },
    },
  }
</script>

<style scoped>
    .center-snackbar .v-snack__wrapper .v-snack__content{
        margin:auto !important;
        width:unset !important;
    }
</style>
